import { translateTranslationTable } from '@/@core/libs/i18n/utils';

export function formatResponse(response, locale) {
	if (response === null || response === undefined || response === '') return '--';

	if (Array.isArray(response)) {
		const formatted = response
			.map(item => formatResponse(item, locale))
			.filter(item => item && item !== '--');
		return formatted.length > 0 ? formatted.join(', ') : '--';
	}

	if (typeof response === 'object') {
		const translated = (response.ca || response.es || response.en) 
			? translateTranslationTable(locale, response) 
			: null;
		return translated || JSON.stringify(response);
	}

	if (typeof response !== 'string') return String(response);

	return cleanStringResponse(response.trim(), locale);
}

function cleanStringResponse(str, locale) {
	const withoutQuotes = (str.startsWith('"') && str.endsWith('"')) || 
	                       (str.startsWith("'") && str.endsWith("'")) 
	                       ? str.slice(1, -1) : str;

	if (!withoutQuotes.startsWith('[') && !withoutQuotes.startsWith('{')) {
		return decodeString(withoutQuotes);
	}

	const parsed = tryParseJSON(withoutQuotes);
	if (parsed !== null) return formatResponse(parsed, locale);

	const unescaped = withoutQuotes.replace(/\\"/g, '"').replace(/\\\\/g, '\\');
	const parsedUnescaped = tryParseJSON(unescaped);
	if (parsedUnescaped !== null) return formatResponse(parsedUnescaped, locale);

	const manual = withoutQuotes.replace(/^\["|"\]$/g, '').replace(/\\"/g, '"');
	return decodeString(manual) || '--';
}

function tryParseJSON(str) {
	try {
		return JSON.parse(str);
	} catch (e) {
		return null;
	}
}

function decodeString(str) {
	return str
		.replace(/\\u([0-9a-fA-F]{4})/g, (_, grp) => String.fromCharCode(parseInt(grp, 16)))
		.replace(/\\"/g, '"')
		.replace(/\\\\/g, '\\');
}

